<template>
  <div>
    <div class="heading">{{ $t('sealing.page_title') }}</div>
    <NewGlassCard class="mt-16" :title="$t('sealing.all_orders')">
      <template v-slot:back-button>
        <v-btn class="back-button mb-6" @click="goOnePageBack()">
          <v-icon color="#6E6E6E">mdi-arrow-left</v-icon>
        </v-btn>
      </template>
      <SealingOverviewTable />
    </NewGlassCard>
  </div>
</template>

<script>
import { NewGlassCard } from '@newnetzportal/netzportal-webapp-storybook-components';
import SealingOverviewTable from '../components/sealing-overview-component/SealingOverviewTable.vue';

export default {
  name: 'SealingPage',
  components: {
    NewGlassCard,
    SealingOverviewTable,
  },
  methods: {
    goOnePageBack() {
      this.$router.push(this.$store.getters.getPreviousPage || '/');
    },
  },
};
</script>

<style scoped>
.heading {
  font-size: 50px;
  margin-bottom: 0;
}

.back-button {
  border-radius: 40px;
  background-color: rgba(255, 255, 255, 0.9);
  height: 35px !important;
  width: 90px;
  box-shadow: none;
  margin-right: 30px;
}
</style>
